import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { Text, Inline } from 'slate';
import { Editor } from 'slate-react';
import DefaultLink from './DefaultLink';
import HTTPLink from './HTTPLink';
import MailToLink from './MailToLink';
import { CloseIcon } from '../../../../components/Icons';
import { isUrlAnEmail, cleanUrl } from '../../../../utils/linkUtils';
import EntityTypes from '../../../../types/EntityTypes';

function getComponent(url) {
  if (url) {
    if (url.indexOf('http') === 0) {
      return HTTPLink;
    }

    if (isUrlAnEmail(url)) {
      return MailToLink;
    }
  }

  return DefaultLink;
}

var LinkPreview =
/*#__PURE__*/
function (_Component) {
  _inherits(LinkPreview, _Component);

  function LinkPreview() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, LinkPreview);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(LinkPreview)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "onRemove", function () {
      var _this$props = _this.props,
          editor = _this$props.editor,
          node = _this$props.node;

      if (editor.props.readOnly) {
        return;
      }

      editor.unwrapInlineByKey(node.key, EntityTypes.LINK);
    });

    return _this;
  }

  _createClass(LinkPreview, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          editor = _this$props2.editor,
          url = _this$props2.url,
          canRemove = _this$props2.canRemove;
      var readOnly = editor.props.readOnly;
      var parsedUrl = cleanUrl(url);
      return React.createElement("div", {
        className: "flexbox flexbox-align-center padding-normal"
      }, React.createElement(getComponent(parsedUrl), {
        url: parsedUrl
      }), !readOnly && canRemove && React.createElement("div", {
        title: "Remove link",
        onClick: this.onRemove,
        className: "pointer flexbox flexbox-align-center margin-left-normal shade-30 shade-10-on-hover"
      }, React.createElement(CloseIcon, null)));
    }
  }]);

  return LinkPreview;
}(Component);

_defineProperty(LinkPreview, "propTypes", {
  text: PropTypes.string,
  offset: PropTypes.number,
  editor: PropTypes.instanceOf(Editor),
  url: PropTypes.string,
  node: PropTypes.oneOfType([PropTypes.instanceOf(Text), PropTypes.instanceOf(Inline)]),
  canRemove: PropTypes.bool
});

_defineProperty(LinkPreview, "defaultProps", {
  canRemove: false
});

export { LinkPreview as default };